import { RotaryErrorFragment } from "@saleor/fragments/types/RotaryErrorFragment";
import { RotaryErrorCode } from "@saleor/types/globalTypes";
import { defineMessages, IntlShape } from "react-intl";

import commonErrorMessages from "./common";

const messages = defineMessages({
  not_found: {
    defaultMessage: "该值为必填项,不能为空"
  },
  required: {
    defaultMessage:
      "现有的Items概率和为100%，请先调节出预留概率或设置新建Item概率为0%"
  },
  unique: {
    defaultMessage: "Items的概率总和大于100%，请重新配置Items"
  }
});

function getRotaryErrorMessage(
  err: Omit<RotaryErrorFragment, "__typename"> | undefined,
  intl: IntlShape
): string {
  if (err) {
    switch (err.code) {
      case RotaryErrorCode.NOT_FOUND:
        return intl.formatMessage(messages.not_found);
      case RotaryErrorCode.UNIQUE:
        return intl.formatMessage(messages.unique);
      case RotaryErrorCode.REQUIRED:
        return intl.formatMessage(messages.required);
      default:
        return intl.formatMessage(commonErrorMessages.unknownError);
    }
  }
}

export default getRotaryErrorMessage;
